import axios from "axios";

export const getCoupons = async (query) => {
  const url =
    axios.getUri({ url: "/api/coupon", params: query }) || `/api/coupon`;

  return axios(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const adminGetCoupon = async (query) => {
  const url =
    axios.getUri({ url: "/api/admin/coupon", params: query }) ||
    `/api/admin/coupon`;

  return axios(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const adminCreateCoupon = async (data) => {
  const url = `/api/admin/coupon`;
  return axios(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  });
};

export const adminUpdateCoupon = async (id, data) => {
  const url = `/api/admin/coupon/${id}`;
  return axios(url, {
    method: "PATCH",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  });
};

export const adminDeleteCoupon = async (id) => {
  const url = `/api/admin/coupon/${id}`;
  return axios(url, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const redeemCoupon = async (code) => {
  const url = `/api/coupon/redeem`;
  return axios(url, {
    method: "post",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ code: code }),
  });
};
